import React, { useState } from "react";

import Grid from '@mui/material/Grid2';
import Box from '@mui/material/Box';
import Typography from "@mui/material/Typography";

import { AppBar, Dialog, IconButton, Slide, Toolbar } from "@mui/material";
import Button from "@components/common/Button";
import CloseIcon from '@mui/icons-material/Close';

import { useStyles } from "./styles";
import { isMobile } from "@utils/browser";

const tAndCDoc = 'https://health-care-public-contents-prod.s3.us-east-1.amazonaws.com/iNaira+Healthcare+Terms+and+Conditions+v04.2025.pdf';
const privacyPolicyDoc = 'https://health-care-public-contents-prod.s3.us-east-1.amazonaws.com/iNaira+Privacy+Policy+v04.2025.pdf';


const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export const TCContent = ({className="terms-and-condition"}) => {
  const classes = useStyles();
  const [tandCModalOpen, setTandCModalOpen] = useState(false);
  const [privacyPolicyModalOpen, setPrivacyPolicyModalOpen] = useState(false);

  const lastUpdatedDate = "Apr 1, 2025";
  return <>
    <div className={`${classes.termsBox} ${className}`}>
        <div className={classes.termsConditionsHeaders}>
          <div className={classes.headerDescription}>
            <Box sx={{display:'flex',justifyContent: 'space-between'}}>
              <Typography variant="h4">iNaira Healthcare Terms & Conditions</Typography>
              <div className={`${classes.lastUpdateContainer} lu-inner`}>
                <Typography>Last Updated : {lastUpdatedDate}</Typography>
              </div>
            </Box>
            
            <Typography>By registering for and using iNaira’s services, you acknowledge and agree to be bound by the Terms and Conditions outlined below. We kindly encourage you to read these terms carefully, as they govern your access to and use of our platform.</Typography>
          </div>
          <div className={`${classes.lastUpdateContainer} lu-outer`}>
            <Typography>Last Updated : {lastUpdatedDate}</Typography>
          </div>
        </div>
        <div className={classes.termstermsConditionsContent}>
          <Dialog
            fullScreen
            open={tandCModalOpen}
            onClose={() => setTandCModalOpen(false)}
            TransitionComponent={Transition}
          >
            <AppBar sx={{ position: 'relative' }}>
              <Toolbar>
                <IconButton
                  edge="start"
                  color="inherit"
                  onClick={() => setTandCModalOpen(false)}
                  aria-label="close"
                >
                  <CloseIcon />
                </IconButton>
                <Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div">
                  iNaira Healthcare Terms & Conditions
                </Typography>
              </Toolbar>
            </AppBar>
            <embed className={classes.EmbeddBody} src={tAndCDoc} type="application/pdf" width="100%" height="100%" />
          </Dialog>
          {
            isMobile() ?
              <a href={tAndCDoc} target="_blank" rel="noopener noreferrer" download>
                <Button size="small" color="primary_new" variant="contained" children="Download Terms and Conditions" />
              </a>
              :
              <Button size="small" color="primary_new" variant="contained" children="Download Terms and Conditions" onClick={() => setTandCModalOpen(true)} />
          }
        </div>
      </div>
      <br />
      <div className={`${classes.termsBox} ${className}`}>
        <div className={classes.termsConditionsHeaders}>
          <div className={classes.headerDescription}>
            <Box sx={{display:'flex',justifyContent: 'space-between'}}>
              <Typography variant="h4">iNaira Healthcare Privacy Policy</Typography>
              <div className={`${classes.lastUpdateContainer} lu-inner`}>
                <Typography>Last Updated : {lastUpdatedDate}</Typography>
              </div>
            </Box>
            <Typography>When you sign up, you agree to be bound by the Privacy policy set forth below. Please read these terms carefully, as they govern your use of our services.</Typography>
          </div>
          <div className={`${classes.lastUpdateContainer} lu-outer`}>
            <Typography>Last Updated : {lastUpdatedDate}</Typography>
          </div>
        </div>
        <div className={classes.termstermsConditionsContent}>
          <Dialog
            fullScreen
            open={privacyPolicyModalOpen}
            onClose={() => setPrivacyPolicyModalOpen(false)}
            TransitionComponent={Transition}
          >
            <AppBar sx={{ position: 'relative' }}>
              <Toolbar>
                <IconButton
                  edge="start"
                  color="inherit"
                  onClick={() => setPrivacyPolicyModalOpen(false)}
                  aria-label="close"
                >
                  <CloseIcon />
                </IconButton>
                <Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div">
                  iNaira Healthcare Privacy Policy
                </Typography>
              </Toolbar>
            </AppBar>
            <embed className={classes.EmbeddBody} src={privacyPolicyDoc} type="application/pdf" width="100%" height="100%" />
          </Dialog>
          {
            isMobile() ?
              <a href={privacyPolicyDoc} target="_blank" rel="noopener noreferrer" download>
                <Button size="small" color="primary_new" variant="contained" children="View Privacy Policy" />
              </a>
              :
              <Button size="small" color="primary_new" variant="contained" children="View Privacy Policy" onClick={() => setPrivacyPolicyModalOpen(true)} />
          }
        </div>
      </div>
  </>
}
const TermsConditions = () => {

  const classes = useStyles();
  return (
    <Grid container className={classes.termsConditionsContainer}>
      <TCContent/>
    </Grid>
  );
};

export default TermsConditions;
